

import React, { Component } from 'react'
import { Route } from 'react-router-dom'

import universal, { setHasBabelPlugin } from 'react-universal-component'

import { cleanPath } from 'react-static'



setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

  const t_0 = universal(import('../src/containers/site/NewHomev6.jsx'), universalOptions)
const t_1 = universal(import('../src/containers/site/PlansAndPriceIndustryv5.jsx'), universalOptions)
const t_2 = universal(import('../src/containers/site/landing-pages/PerformanceIndicators.jsx'), universalOptions)
const t_3 = universal(import('../src/containers/site/landing-pages/Segmentos.jsx'), universalOptions)
const t_4 = universal(import('../src/containers/site/landing-pages/SegmentosAlimentos.jsx'), universalOptions)
const t_5 = universal(import('../src/containers/site/PlansAndPriceRepresentativev5.jsx'), universalOptions)
const t_6 = universal(import('../src/components/RedirectToUrl.jsx'), universalOptions)
const t_7 = universal(import('../src/containers/site/recursos/SalesForcev3.jsx'), universalOptions)
const t_8 = universal(import('../src/containers/site/landing-pages/Retargeting.jsx'), universalOptions)
const t_9 = universal(import('../src/containers/site/landing-pages/Videochamada.jsx'), universalOptions)
const t_10 = universal(import('../src/containers/site/landing-pages/DistributorSystemv3.jsx'), universalOptions)
const t_11 = universal(import('../src/containers/site/landing-pages/IndustrySystemv2.jsx'), universalOptions)
const t_12 = universal(import('../src/containers/site/landing-pages/IndustrySystemWhatsappRedirect.jsx'), universalOptions)
const t_13 = universal(import('../src/containers/site/landing-pages/PoliticasComerciais.jsx'), universalOptions)
const t_14 = universal(import('../src/containers/site/recursos/CRM.jsx'), universalOptions)
const t_15 = universal(import('../src/containers/site/recursos/CRMLp.jsx'), universalOptions)
const t_16 = universal(import('../src/containers/site/landing-pages/crm-html-lps/CrmHtmlLp.jsx'), universalOptions)
const t_17 = universal(import('../src/containers/site/recursos/MercosIA.jsx'), universalOptions)
const t_18 = universal(import('../src/containers/site/RelatorioIgualdade.jsx'), universalOptions)
const t_19 = universal(import('../src/containers/site/landing-pages/RepresentativeSystemv2.jsx'), universalOptions)
const t_20 = universal(import('../src/containers/site/landing-pages/DistributorSystemv2.jsx'), universalOptions)
const t_21 = universal(import('../src/containers/site/Representativev3.jsx'), universalOptions)
const t_22 = universal(import('../src/containers/site/landing-pages/SalesApplicationv4.jsx'), universalOptions)
const t_23 = universal(import('../src/containers/site/landing-pages/SalesApplicationv2.jsx'), universalOptions)
const t_24 = universal(import('../src/containers/site/landing-pages/PmaxIndustriasDistribuidoras.jsx'), universalOptions)
const t_25 = universal(import('../src/containers/site/landing-pages/PmaxRepresentantes.jsx'), universalOptions)
const t_26 = universal(import('../src/containers/site/landing-pages/RepresentationSoftwarev2.jsx'), universalOptions)
const t_27 = universal(import('../src/containers/site/recursos/SistemaDePedidosComIA.jsx'), universalOptions)
const t_28 = universal(import('../src/containers/site/landing-pages/ProductOverview.jsx'), universalOptions)
const t_29 = universal(import('../src/containers/site/landing-pages/MeusPedidosv2.jsx'), universalOptions)
const t_30 = universal(import('../src/containers/site/landing-pages/FreeTrialv2.jsx'), universalOptions)
const t_31 = universal(import('../src/containers/site/landing-pages/ECommerceB2bv3.jsx'), universalOptions)
const t_32 = universal(import('../src/containers/site/landing-pages/EuCommerce.jsx'), universalOptions)
const t_33 = universal(import('../src/containers/site/landing-pages/EuCommerceTP.jsx'), universalOptions)
const t_34 = universal(import('../src/containers/site/landing-pages/B2BMesDaIndustria.jsx'), universalOptions)
const t_35 = universal(import('../src/containers/site/landing-pages/B2BRep.jsx'), universalOptions)
const t_36 = universal(import('../src/containers/site/landing-pages/ECommerceRep.jsx'), universalOptions)
const t_37 = universal(import('../src/containers/site/landing-pages/MercosPay.jsx'), universalOptions)
const t_38 = universal(import('../src/containers/site/landing-pages/BlackNovember.jsx'), universalOptions)
const t_39 = universal(import('../src/containers/site/landing-pages/BlackNovemberRep.jsx'), universalOptions)
const t_40 = universal(import('../src/containers/site/landing-pages/BlackNovemberTP.jsx'), universalOptions)
const t_41 = universal(import('../src/containers/site/landing-pages/BlackNovemberRepTP.jsx'), universalOptions)
const t_42 = universal(import('../src/containers/site/landing-pages/ThankYouPageDemosv2.jsx'), universalOptions)
const t_43 = universal(import('../src/containers/site/landing-pages/ClienteExpansao.jsx'), universalOptions)
const t_44 = universal(import('../src/containers/site/landing-pages/CadastroOportunidadeExpansao.jsx'), universalOptions)
const t_45 = universal(import('../src/containers/site/landing-pages/ImersaoEmVendas.jsx'), universalOptions)
const t_46 = universal(import('../src/containers/site/landing-pages/RemarketingReps.jsx'), universalOptions)
const t_47 = universal(import('../src/containers/site/landing-pages/RemarketingDist.jsx'), universalOptions)
const t_48 = universal(import('../src/containers/site/landing-pages/ImersaoEmVendasTP.jsx'), universalOptions)
const t_49 = universal(import('../src/containers/site/landing-pages/OfertaConversao.jsx'), universalOptions)
const t_50 = universal(import('../src/containers/site/landing-pages/MarceloCaetano.jsx'), universalOptions)
const t_51 = universal(import('../src/containers/covidcampaign/CovidMaterials.jsx'), universalOptions)
const t_52 = universal(import('../src/containers/covidcampaign/CovidMaterialPage.jsx'), universalOptions)
const t_53 = universal(import('../src/containers/site/NewAboutv2.jsx'), universalOptions)
const t_54 = universal(import('../src/containers/site/PrivacyNotice.jsx'), universalOptions)
const t_55 = universal(import('../src/containers/site/PrivacyNoticeChromeExtension.jsx'), universalOptions)
const t_56 = universal(import('../src/containers/site/TermsAndConditions.jsx'), universalOptions)
const t_57 = universal(import('../src/containers/site/Partnersv2.jsx'), universalOptions)
const t_58 = universal(import('../src/containers/marketplace/MarketplaceSearchv2.jsx'), universalOptions)
const t_59 = universal(import('../src/containers/marketplace/MarketplacePartnerv2.jsx'), universalOptions)
const t_60 = universal(import('../src/containers/site/landing-pages/ConquerMarketsv2.jsx'), universalOptions)
const t_61 = universal(import('../src/components/TrackAndGo.jsx'), universalOptions)
const t_62 = universal(import('../src/containers/site/landing-pages/MeuMelhorAnov2.jsx'), universalOptions)
const t_63 = universal(import('../src/containers/site/NewPartner/NewPartnerv2.jsx'), universalOptions)
const t_64 = universal(import('../src/containers/landing-pages-partners/Omie.jsx'), universalOptions)
const t_65 = universal(import('../src/containers/landing-pages-partners/AlterData.jsx'), universalOptions)
const t_66 = universal(import('../src/containers/landing-pages-partners/Bling.jsx'), universalOptions)
const t_67 = universal(import('../src/containers/landing-pages-partners/Intelidata.jsx'), universalOptions)
const t_68 = universal(import('../src/containers/landing-pages-partners/Wk.jsx'), universalOptions)
const t_69 = universal(import('../src/containers/landing-pages-partners/Intelitech.jsx'), universalOptions)
const t_70 = universal(import('../src/containers/landing-pages-partners/Questor.jsx'), universalOptions)
const t_71 = universal(import('../src/containers/404v2.jsx'), universalOptions)


// Template Map
global.componentsByTemplateID = global.componentsByTemplateID || [
  t_0,
t_1,
t_2,
t_3,
t_4,
t_5,
t_6,
t_7,
t_8,
t_9,
t_10,
t_11,
t_12,
t_13,
t_14,
t_15,
t_16,
t_17,
t_18,
t_19,
t_20,
t_21,
t_22,
t_23,
t_24,
t_25,
t_26,
t_27,
t_28,
t_29,
t_30,
t_31,
t_32,
t_33,
t_34,
t_35,
t_36,
t_37,
t_38,
t_39,
t_40,
t_41,
t_42,
t_43,
t_44,
t_45,
t_46,
t_47,
t_48,
t_49,
t_50,
t_51,
t_52,
t_53,
t_54,
t_55,
t_56,
t_57,
t_58,
t_59,
t_60,
t_61,
t_62,
t_63,
t_64,
t_65,
t_66,
t_67,
t_68,
t_69,
t_70,
t_71
]

// Template Tree
global.templateIDsByPath = global.templateIDsByPath || {
  '404': 71
}

// Get template for given path
const getComponentForPath = path => {
  path = cleanPath(path)
  return global.componentsByTemplateID[global.templateIDsByPath[path]]
}

global.reactStaticGetComponentForPath = getComponentForPath
global.reactStaticRegisterTemplateIDForPath = (path, id) => {
  global.templateIDsByPath[path] = id
}

export default class Routes extends Component {
  render () {
    const { component: Comp, render, children } = this.props

    const getFullComponentForPath = path => {
      let Comp = getComponentForPath(path)
      let is404 = path === '404'
      if (!Comp) {
        is404 = true
        Comp = getComponentForPath('404')
      }
      return newProps => (
        Comp
          ? <Comp {...newProps} {...(is404 ? {is404: true} : {})} />
          : null
      )
    }

    const renderProps = {
      componentsByTemplateID: global.componentsByTemplateID,
      templateIDsByPath: global.templateIDsByPath,
      getComponentForPath: getFullComponentForPath
    }

    if (Comp) {
      return (
        <Comp
          {...renderProps}
        />
      )
    }

    if (render || children) {
      return (render || children)(renderProps)
    }

    // This is the default auto-routing renderer
    return (
      <Route path='*' render={props => {
        let Comp = getFullComponentForPath(props.location.pathname)
        // If Comp is used as a component here, it triggers React to re-mount the entire
        // component tree underneath during reconciliation, losing all internal state.
        // By unwrapping it here we keep the real, static component exposed directly to React.
        return Comp && Comp({ ...props, key: props.location.pathname })
      }} />
    )
  }
}




// WEBPACK FOOTER //
// /usr/src/site-blog/dist/react-static-routes.js